export const HEADER_CREATE_GROUP_BUTTON = 'header-create-group-button';
export const HEADER_SEARCH_BUTTON = 'header-search-button';
export const HEADER_SEARCH_DRAWER = 'header-search-drawer';
